// eslint-disable-next-line import/no-unresolved
import { sendGTMEvent } from '@next/third-parties/google';

export const getGTMCode = () => {
	if (typeof window == 'undefined') return '';

	const localhostCode = '';
	const stageCode = 'GTM-PWC4R5K6';
	const productionCode = 'GTM-KF9CF3K';

	const forceApplyGTM = false;
	const isLocalHost = window.location.href.includes('localhost');
	const isStage = window.location.href.includes('stg');

	if (forceApplyGTM) return stageCode;
	if (isLocalHost) return localhostCode;
	if (isStage) return stageCode;

	return productionCode;
};

export const sendCustomGTMEvent = (data) => sendGTMEvent({ event: 'event', ...data });
